export enum EAuthStrategy {
  Unauthenticated = 'UnauthenticatedStrategy',
  Password = 'PasswordStrategy',
  DeepLink = 'DeepLinkStrategy',
  MagicLink = 'MagicLinkStrategy',
  Certificate = 'CertificateStrategy',
}
